import React from "react";
import javaLogo from "../../assets/images/tech-logos/java.svg";
import defaultLogo from "../../assets/images/tech-logos/default.svg";
import cloudLogo from "../../assets/images/tech-logos/cloud.svg";
import artificialIntelligenceImage from "../../assets/images/about-ai/artificial-intelligence.png";
import generativeAiImage from "../../assets/images/about-ai/generative-ai.png";

const capabilities = [
  {
    image: javaLogo,
    title: "JDK Upgrade",
    focus: "Java 8 to Java 21 modernization",
    improvement: "78%",
    practice: "Run dependency audit, compatibility scan, and staged migration.",
    output: "Cleaner migration plan with compatibility checks"
  },
  {
    image: defaultLogo,
    title: "JUnit Generation",
    focus: "Repository to test coverage",
    improvement: "72%",
    practice: "Prioritize critical paths, edge cases, and repeatable test data.",
    output: "Generated tests and validation support"
  },
  {
    image: artificialIntelligenceImage,
    title: "Code Scan",
    focus: "API, security, and maintainability review",
    improvement: "68%",
    practice: "Use static analysis, secure coding checks, and peer review.",
    output: "Risk report with recommended fixes"
  },
  {
    image: cloudLogo,
    title: "CI/CD Quality",
    focus: "Build, validate, and release workflow",
    improvement: "84%",
    practice: "Automate build gates, test stages, and release validation.",
    output: "Stable delivery pipeline checks"
  },
  {
    image: generativeAiImage,
    title: "Log Insights",
    focus: "Error pattern and root-cause analysis",
    improvement: "68%",
    practice: "Centralize logs, standardize correlation IDs, and track alerts.",
    output: "Faster issue diagnosis"
  },
  {
    image: defaultLogo,
    title: "Docs + Review",
    focus: "Documentation and code-review assistance",
    improvement: "74%",
    practice: "Keep decision records, review checklists, and readable summaries.",
    output: "Readable summaries and review notes"
  }
];

function Products() {
  return (
    <section id="products" className="products smartflow-page">
      <div className="product-summary">
        <h2>SmartFlow</h2>
        <p>
          A simple AI-assisted workflow platform for modernization, testing,
          quality checks, and engineering delivery.
        </p>
      </div>

      <div className="product-table-wrap">
        <table className="product-table">
          <thead>
            <tr>
              <th>Area</th>
              <th>Capability</th>
              <th>Focus</th>
              <th>Output</th>
              <th>Improvement</th>
              <th>Engineering Best Practice</th>
            </tr>
          </thead>
          <tbody>
            {capabilities.map((item) => (
              <tr key={item.title}>
                <td>
                  <span className="product-table-image">
                    <img src={item.image} alt="" />
                  </span>
                </td>
                <td><strong>{item.title}</strong></td>
                <td>{item.focus}</td>
                <td>{item.output}</td>
                <td><span className="product-improvement">{item.improvement}</span></td>
                <td>{item.practice}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default Products;
